import {getSearchResultsByQuery} from "../services/search-service";
import {loadSearchQueries, saveSearchQueries} from "../services/local-storage-service";

export const SEARCH_LOADING = 'SEARCH_LOADING';
export const SEARCH_RESULT = 'SEARCH_RESULT';
export const SEARCH_ERROR = 'SEARCH_ERROR';
export const SET_PREVIOUS_QUERIES = 'SET_PREVIOUS_QUERIES';

export const searchQueryAction = (query, previous, rank) => {
    return async (dispatch) => {
        dispatch({ type: SEARCH_LOADING, });
        try {
            const responsePromise =  getSearchResultsByQuery(query, rank)

            if (previous && !previous.some(item => item === query)) {
                const queries = [...previous, query]
                saveSearchQueries(queries)
                dispatch(loadPreviousSearchQueries(queries));
            }

            const response = await responsePromise
            if (response.ok) {
                const results = await response.json()
                dispatch({
                    type: SEARCH_RESULT,
                    payload: { results }
                })
            } else {
                dispatch({
                    type: SEARCH_ERROR,
                    payload: { error: { status: response.status, message: response.statusText }},
                })
            }
        } catch (error) {
            dispatch({
                type: SEARCH_ERROR,
                payload: { error },
            })
        }
    }
}

export const loadPreviousSearchQueries = (queries) => {
    return dispatch => {
        const previousQueries = queries || loadSearchQueries() || [];
        dispatch({ type: SET_PREVIOUS_QUERIES, payload: { previous: previousQueries }});
    }
}
